import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vjoffice-locations',
  templateUrl: './vjoffice-locations.component.html',
  styleUrls: ['./vjoffice-locations.component.css']
})
export class VJOfficeLocationsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
